<template>
    <div>
        <div class="field is-horizontal" v-if="isTextAnswer">
            <div class="field-body" >
                <button
                    class="button control is-ghost has-text-danger"
                    @click="$emit('remove')"
                >
                    <span class="icon">
                        <i class="mdi mdi-24px mdi-delete"></i>
                    </span>
                </button>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input
                            v-model="sourceAnswer.value"
                            :placeholder="$t('creation.answer_hint')"
                            class="input"
                            type="text"
                            @change="addAnswer"
                        />
                    </div>
                </div>
                <div v-if="answerType == 'MULTIPLE' || answerType == 'SINGLE'">
                    <label class="switch">
                        <input
                            v-model="sourceAnswer.correct"
                            :disabled="disableSwitch"
                            type="checkbox"
                            @change="addAnswer"
                        />
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </div>
        <div v-else-if="answerType=='RANGE'">
            <div class="columns is-vcentered">
                <div class="column">
                    <p class="">{{ $t('answer_min_value') }}</p>
                </div>
                <div class="column is-5">
                    <input
                        v-model="sourceAnswer.valueMin"
                        :placeholder="$t('min_val')"
                        class="input is-pulled-right"
                        type="number"
                        step=".01"
                        @change="addAnswer"
                    />
                </div>
            </div>
            <div class="columns is-vcentered">
                <div class="column">
                    <p class="">{{ $t('answer_max_value') }}</p>
                </div>
                <div class="column is-5">
                    <input
                        v-model="sourceAnswer.valueMax"
                        :placeholder="$t('max_val')"
                        class="input is-pulled-right"
                        type="number"
                        step=".01"
                        @change="addAnswer"
                    />
                </div>
            </div>
        </div>
        <div v-else-if="answerType=='NUMERIC'">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <input
                        v-model="sourceAnswer.value"
                        :placeholder="$t('number_value')"
                        class="input is-pulled-right"
                        type="number"
                        step=".01"
                        @change="addAnswer"
                    />
                </div>
            </div>
        </div>
  
    </div>
</template>

<script>
export default {
    name: 'InputAnswer',
    components: {},
    model: {
        prop: 'sourceAnswer',
    },
    props: {
        sourceAnswer: {
            type: Object,
            default: () => {
                return {};
            },
        },
        answerType: {
            type: String,
            default: () => {
                return '';
            },
        },
        disableSwitch: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
    },
    data() {
        return {
            checkValue: undefined,
            answer: this.sourceAnswer,
        };
    },
    computed: {
        isTextAnswer() {
            // console.log(this.answerType != 'NUMERIC' && this.answerType != 'RANGE')
            return this.answerType != 'NUMERIC' && this.answerType != 'RANGE';
        },
    },
    methods: {
        addAnswer() {
            if (this.answerType == 'HANGMAN' || this.answerType == 'FREETEXT'|| this.answerType == 'NUMERIC' || this.answerType == 'RANGE') {
                this.sourceAnswer.correct = true;
            }
            this.$emit('input', this.sourceAnswer);
        },
    },
};
</script>

<style scoped></style>
